import { object, string, number, boolean, ValidationError } from "yup";
import * as Sentry from "@sentry/react";
import { parse } from "tldts";

export const MonitoringCreateFormSchema = object({
  domain: string()
    // Deliberately forwards the input as typed rather than reducing it to a
    // hostname. The API canonicalizes the target itself, and unlike the browser
    // it knows which hosts are platform domains: it flattens
    // "https://www.example.com/pricing" to "example.com" but keeps
    // "https://www.instagram.com/acme" as "instagram.com/acme". Reducing to
    // url.hostname here dropped the path, so a platform URL pasted with its
    // scheme reached the API as a bare "www.instagram.com", which it rejects
    // with: "www.instagram.com" is a known social media domain.
    .transform((value) => {
      try {
        return (value as string).trim();
      } catch (e) {
        Sentry.captureException(e);
        return value;
      }
    })
    .test(
      "domain",
      "Enter a valid domain name (e.g. example.com)",
      function (value) {
        if (!value) {
          return false;
        }

        return parse(value)?.domain != null;
      }
    )
    .required(),
  profile_id: string().nullable(),
  external_ref_id: string().nullable(),
  closure_selected: boolean().required(),
  frequency_days: number().required(),
  content_selected: boolean().required(),
  sentiment_selected: boolean().required(),
  profile_selected: boolean().required(),
  connected_entities_selected: boolean().required(),
  people_selected: boolean().required(),
}).test("monitor_selection", "Please select at least one", (obj) => {
  const nothingSelected =
    !obj.closure_selected &&
    !obj.content_selected &&
    !obj.sentiment_selected &&
    !obj.connected_entities_selected &&
    !obj.people_selected &&
    !obj.profile_selected;
  if (nothingSelected) {
    return new ValidationError(
      "Please select at least one",
      undefined,
      "monitor_selection"
    );
  }
  return true;
});
